import type { ComponentPropsWithRef } from 'react';
import React from 'react';

import { Text } from '@headout/eevee';

type Props = {
	id?: string;
	className?: string;
	onClick?: (...args: any[]) => any;
	children?: React.ReactNode;
	testId?: string;
};

/**
 * Localized h3 component
 * Disable google-translate by default
 * @deprecated Use `NewLH3` instead
 */
const LH3 = ({ id, className, onClick, children, testId }: Props) => (
	<h3
		{...(testId && { 'data-testid': testId })}
		id={id}
		className={`notranslate ${className || ''}`}
		onClick={onClick}
	>
		{children}
	</h3>
);

export default LH3;

export const NewLH3 = ({
	className,
	testId,
	...props
}: ComponentPropsWithRef<typeof Text> & {
	testId?: string;
}) => (
	<Text
		className={`notranslate ${className || ''}`}
		{...props}
		{...(testId && { 'data-testid': testId })}
		as='h3'
	/>
);
